<template>
    <div :style="[elementStyles, basicContentStyles]">
        <div>
            <img :src="icon_url" v-bind:style="icon_style"/>
        </div>
        <div>
            <div v-bind:style="primary_styles" v-html="degree"></div>
            <div v-bind:style="secondary_styles" v-html="weatherDescription"></div>
        </div>
    </div>
</template>

<script>
    import toaster from "../../common/toaster";

    export default {
        props: ['data', 'frame', 'basicContentStyles', 'width', 'height'],
        data: function () {
            return {
                t_update_weather_failed: Lang.langGet("The weather could not be updated (openweathermap.org)!"),
                degree: '',
                weatherDescription: '',
                icon: '01d',
            }
        },
        computed: {
            elementStyles: function () {
                let opacity = 1;
                if (!isNaN(this.data.transparency)) {
                    opacity -= this.data.transparency/100;
                }
                // 0.999: such that border when selected is visualized correctly.
                opacity = Math.min(opacity, 0.999);

                return {
                    boxShadow: '1px 1px #cccccc inset, -1px -1px #cccccc inset',
                    opacity: opacity,
                }
            },
            primary_styles: function () {
                let fontsize = 30;
                let fontfamily = 'Arial';

                if (typeof this.data.text_size !== 'undefined' && this.data.text_size !== null && this.data.text_size != '') {
                    fontsize = this.data.text_size;
                }

                if (typeof this.data.text_family !== 'undefined' && this.data.text_family !== null && this.data.text_family.length > 0) {
                    fontfamily = this.data.text_family;
                }

                fontsize = parseInt(fontsize) * this.frame.ratio;

                return {
                    fontSize: fontsize + 'px',
                    fontFamily: '"' + fontfamily + '"',
                    textDecoration: this.textDecoration,
                    fontStyle: this.fontStyle,
                    fontWeight: this.fontWeight,
                    color: this.data.primary_color,
                    lineHeight: 'normal'
                }
            },
            secondary_styles: function () {
                let fontsize = 30;
                let fontfamily = 'Arial';

                if (typeof this.data.text_size !== 'undefined' && this.data.text_size !== null && this.data.text_size != '') {
                    fontsize = this.data.text_size;
                }

                if (typeof this.data.text_family !== 'undefined' && this.data.text_family !== null && this.data.text_family.length > 0) {
                    fontfamily = this.data.text_family;
                }

                fontsize = parseInt(fontsize) * this.frame.ratio;

                return {
                    fontSize: fontsize + 'px',
                    fontFamily: '"' + fontfamily + '"',
                    textDecoration: this.textDecoration,
                    fontStyle: this.fontStyle,
                    fontWeight: this.fontWeight,
                    color: this.data.secondary_color,
                    lineHeight: 'normal'
                }
            },
            textDecoration: function () {
                if (this.data.text_decoration === 'underline') {
                    return 'underline';
                }

                return 'none';
            },
            fontStyle: function () {
                if (this.data.text_style === 'italic') {
                    return 'italic';
                }

                return 'normal';
            },
            fontWeight: function () {
                if (this.data.text_weight === 'bold') {
                    return 'bold';
                }

                return 'normal';
            },
            icon_url: function () {
                return '/img/weather/' + this.icon + '.png';
            },
            icon_style: function () {
                return {
                    width: 50 * this.frame.ratio + 'px',
                }
            }
        },
        methods: {
            updateWeather: function () {
                axios.get('/weather?language=' + this.data.language + "&city=" + (this.data.city ?? '')).then((response) => {
                    this.degree = Math.round(parseFloat(response.data.data.main.temp)) + '&deg;C';
                    this.weatherDescription = response.data.data.weather[0].description;
                    this.icon = response.data.data.weather[0].icon;
                }).catch(() => {
                    toaster.error(this.t_update_weather_failed);
                });
            }
        },
        mounted() {
            this.updateWeather();

            EaseEventBus.listen('updateWeather', () => {
                this.updateWeather();
            });
        }
    }
</script>
